// extracted by mini-css-extract-plugin
module.exports = {"welcome":"Welcome_welcome__GhE6t","welcome__logo":"Welcome_welcome__logo__26Aug"};